import type { SalesCloseOutStatus } from '../../api/types';

/** CSE close-out vocabulary (§7.1). Hints state the EXPIRY, because "what does
 *  dismiss actually do" is the question a rep asks before using it once. */
export const STATUS_ACTIONS: {
  value: SalesCloseOutStatus;
  label: string;
  hint: string;
}[] = [
  { value: 'contacted', label: 'Contacted', hint: 'You reached them. Rests for 14 days.' },
  { value: 'follow_up', label: 'Follow up', hint: 'Comes back on the date you pick.' },
  { value: 'no_opportunity', label: 'No opportunity', hint: 'Nothing to sell them now. Rests for 60 days.' },
  { value: 'dismissed', label: 'Dismiss', hint: 'Hidden until the score worsens or the week turns over.' },
  { value: 'do_not_call', label: 'Do not call', hint: 'Standing instruction. Never resurfaces on its own.' },
];

/** Optional (§7.2). The free-text note carries what this cannot. */
export const REASON_CODES: { value: string; label: string }[] = [
  { value: '', label: 'No reason' },
  { value: 'no_inventory', label: 'No inventory' },
  { value: 'price', label: 'Price' },
  { value: 'using_competitor', label: 'Using a competitor' },
  { value: 'relationship', label: 'Relationship' },
  { value: 'service_issue', label: 'Service issue' },
  { value: 'seasonal', label: 'Seasonal' },
  { value: 'wrong_contact', label: 'Wrong contact' },
  { value: 'other', label: 'Other' },
];

export function statusLabel(value?: string | null): string {
  if (!value) return '';
  return STATUS_ACTIONS.find((a) => a.value === value)?.label ?? value;
}
